
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z","fill":"#F9BEF9"}}),_c('path',{attrs:{"d":"M11.046 37.868s1.352-5.059 8.78-5.059c7.43 0 8.794 5.242 8.794 5.242","fill":"#F9BEF9"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"40","height":"40"}},[_c('path',{attrs:{"d":"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z","fill":"#F9BEF9"}}),_c('path',{attrs:{"d":"M11.046 37.868s1.352-5.059 8.78-5.059c7.43 0 8.794 5.242 8.794 5.242","fill":"#F9BEF9"}})]),_c('g',{attrs:{"mask":"url(#a)","stroke":"#000","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M32.456 19.46H7.72v21.944h24.737V19.459z","fill":"#FED766"}}),_c('path',{attrs:{"d":"M7.778 19.454L20.116 2.807l12.34 16.647-2.839 3.585-3.327-3.585-2.839 3.585-3.327-3.585-2.772 3.585-3.329-3.585-2.975 3.585-3.329-3.585H7.778z","fill":"#FFF5D9","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.088 2.807L16.842 7.32h6.491l-3.245-4.513z","fill":"#565961"}}),_c('path',{attrs:{"d":"M21.772 32.142s-.352 1.282-1.897 1.282c-1.546 0-1.897-1.282-1.897-1.282M23.607 29.721s.25-.91 1.349-.91c1.098 0 1.348.91 1.348.91M13.739 29.721s.25-.91 1.348-.91c1.099 0 1.348.91 1.348.91","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    